export default "__VITE_ASSET__C_SMqn7q__"